import { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, Tooltip, Zoom, Grid, Divider, Chip } from '@mui/material';
import { List as ListIcon, SearchOutlined as DetailsIcon, Check as CheckIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { CircleLoader } from 'components';
import React from 'react';

interface IShipmentListProps {
    sku: string
    orderId: string
}

interface IShipmentLine {
    shipmentId: string
    sku: string
    quantity: number
    isInvoiced: boolean
    serialNumbers: ISerial[]
}

interface ISerial {
    serialNumber: string
    serialNumberIsReturned: boolean
    serialNumberCancellationDate?: moment.Moment | null
    serialNumberUpdatedOn: moment.Moment
}

let ShipmentList = ({ sku, orderId }: IShipmentListProps) => {
    let [open, setOpen] = useState<boolean>(false);

    let [isLoading, setLoading] = useState<boolean>(true);
    let [shipments, setShipments] = useState<IShipmentLine[]>([]);


    useEffect(() => {
        if (open === true)
            loadShipments()
    }, [open, orderId]);


    let loadShipments = async () => {
        try {
            setLoading(true);

            let res = await axios.get('/api/Order/GetOrderShipments', { params: { orderId: orderId, sku: sku } });

            let { items } = res.data;

            setShipments(items);
        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    return (
        <>
            <IconButton onClick={() => setOpen(true)} style={{ padding: 4 }}>
                <ListIcon />
            </IconButton>
            {open === true &&
                <Dialog
                    open={open}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle>Shipments of {sku}</DialogTitle>
                    <DialogContent>
                        {isLoading === true && <CircleLoader />}
                        {isLoading !== true &&
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Shipment ID</TableCell>
                                        <TableCell>Serial Numbers</TableCell>
                                        <TableCell align='right' />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {shipments.map((shipmentLine, index) =>
                                        <TableRow hover key={index}>
                                            <TableCell>
                                                {shipmentLine.shipmentId}
                                            </TableCell>
                                            <TableCell>

                                                <Grid container spacing={0.5} style={{ width: 'fit-content' }}>
                                                    {shipmentLine.serialNumbers && shipmentLine.serialNumbers.map((serialNr, serialIx) =>
                                                        <React.Fragment key={serialIx}>
                                                            <Grid item xs>
                                                                <Typography variant='body1'>{serialNr.serialNumber}</Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                {serialNr.serialNumberIsReturned === true &&
                                                                    <Chip icon={<CheckIcon />} label="Returned" size='small' />
                                                                }
                                                            </Grid>
                                                            {(serialIx < shipmentLine.serialNumbers.length - 1) &&
                                                                <Grid item xs={12}>
                                                                    <Divider />
                                                                </Grid>
                                                            }
                                                        </React.Fragment>
                                                    )}
                                                </Grid>

                                            </TableCell>
                                            <TableCell align='right'>
                                                <Tooltip TransitionComponent={Zoom} title="Details">
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        component={Link}
                                                        to={{
                                                            pathname: `/shipment/${shipmentLine.shipmentId}`,
                                                        }}
                                                    >
                                                        <DetailsIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                                {shipments.length <= 0 &&
                                    <TableFooter>
                                        <TableRow>
                                            <TableCell colSpan={3}>
                                                <Typography variant="subtitle2">No shipments found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                }
                            </Table>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='outlined'
                            onClick={() => setOpen(false)}
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    );
}

export default ShipmentList;